import React, { useEffect, useState } from 'react'
import { IoEyeOutline, IoEyeOffOutline } from 'react-icons/io5'
import klaimage from '../../Assets/Niyamasabha front gate .JPG'
import logo from '../../Assets/kla-logo.png'
import './Login.css'
import { loginAPI, verifyOtp } from '../../Services/allApi'
import { useNavigate } from 'react-router-dom'
import { Icon } from '@iconify/react/dist/iconify.js'
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function Login() {
  const navigate = useNavigate()
  const [isLoginClicked, setisLoginClicked] = useState(false)
  const [otpSUbmitted, setOtpSUbmitted] = useState(false)
  const [values, setValues] = useState({
    email: '',
    password: ''
  })
  const [otpInput, setOtpInput] = useState()
  const [loginDo, setLoginDo] = useState(false)

  const [visibility, setVisibility] = useState(false)
  //whenever the user types in the input field the value is stored in the state named 'values'
  const onInputChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value })
  }

  //handelLogin is called when user click on Login button
  const handleLogin = async (e) => {
    //!setisLoginClicked(true)
    e.preventDefault()
    //ckecks whether both email and password field are filled before calling api
    if (values.email && values.password) {
      setLoginDo(true)
      const result = await loginAPI(values)
      console.log(result);
      console.log(values);
      //if the login is successfull then store the tokens ,user id expiration time received from server in session Storage of browser
      if (result.data?.code == 200) {
        sessionStorage.setItem('access_token', result?.data['access_token'])
        sessionStorage.setItem('refresh_token', result?.data['refresh_token'])
        sessionStorage.setItem('user_id', result?.data['user_id'])
        localStorage.setItem('email', result?.data?.email)
        console.log(result.data['expires_at'])
        sessionStorage.setItem('tokenExpirationTime', result?.data['expires_at']);
        localStorage.setItem('sel', 'home')
        if (result?.data?.data?.is_otp_enabled) {
          setisLoginClicked(true)
          toast.info("OTP sended to your email")
          setTimer(30); // Reset timer to 30 seconds
          setIsCounting(true); // Start counting
        }
        else {
          setisLoginClicked(false)
          toast.success("Login Successfull")
          navigate('/octobersky')
        }
      }
      else {
        toast.error(result?.response?.data?.message)
        setLoginDo(false)
      }
    }
    else {
      if (!values.email && !values.password) {
        toast.warning("Please enter Email and Password")
      } else if (values.email) {
        toast.warning("Please enter your Password")
      } else {
        toast.warning("Please enter your Email")
      }
    }

  }

  //function to hide or show password
  const onVisibility = () => {
    setVisibility(!visibility)
  }

  const handleSubmitOtp = async (e) => {
    e.preventDefault()
    if (otpInput) {
      setOtpSUbmitted(true);
      const newValues = { ...values, otp: otpInput };

      // Show the loading toast while waiting for the response
      const toastId = toast.loading("Verifying...");

      try {
        const res = await verifyOtp(newValues);
        console.log(res);

        if (res?.data?.code === 200) {
          sessionStorage.setItem('access_token', res?.data['access_token']);
          sessionStorage.setItem('refresh_token', res?.data['refresh_token']);
          sessionStorage.setItem('user_id', res?.data['user_id']);
          localStorage.setItem('email', res?.data?.email);
          sessionStorage.setItem('tokenExpirationTime', res?.data['expires_at']);
          localStorage.setItem('sel', 'home');
          navigate('/octobersky');

          // Update the toast to show success
          toast.update(toastId, {
            render: "Verification Successful!",
            type: "success",
            isLoading: false,
            autoClose: 3000,
          });
        } else {
          // Update the toast to show error message
          toast.update(toastId, {
            render: res?.response?.data?.message || 'Verification failed!',
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
        }
      } catch (error) {
        console.error(error);

        // Handle unexpected errors (like network issues)
        toast.update(toastId, {
          render: "An unexpected error occurred!",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
      } finally {
        setOtpSUbmitted(false);
      }
    } else {
      toast.warning("Please enter OTP");
    }
  };

  const handleEmailEdit = () => {
    setLoginDo(false)
    setisLoginClicked(false)
    setOtpSUbmitted(false)
  }

  const [timer, setTimer] = useState(30);
  const [isCounting, setIsCounting] = useState(false);

  useEffect(() => {
    let interval;

    if (isCounting && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setIsCounting(false); // Stop counting when timer reaches 0
    }

    return () => clearInterval(interval); // Clear interval on component unmount or when timer stops
  }, [isCounting, timer]);

  const handleResendClick = async () => {
    if (values.email && values.password) {
      const result = await loginAPI(values)
      //if the login is successfull then store the tokens ,user id expiration time received from server in session Storage of browser
      if (result.data?.code == 200) {
        toast.info("OTP Resended")
        setTimer(30); // Reset timer to 30 seconds
        setIsCounting(true); // Start counting
      }
      else {
        toast.error(result?.response?.data?.message ?? "OTP sending failed")
      }
    }
  };
  return (
    <>

      <div className=' w-full h-screen overflow-y-auto sm:gradient-primary sm:flex sm:flex-col' style={{ fontFamily: 'Ropa Sans' }}>
        <div className='p-2 flex w-auto cursor-pointer items-center sm:ml-0 md:ml-12'><img className='w-16 h-12' alt='logo' src={logo} />
          <div className='block sm:hidden m-3 font-sans font-bold text-2xl'>Niyamasabha</div>
        </div>

        <div className="sm:flex-1 flex w-full items-center justify-center">
          <div className=' mt-0 sm:flex sm:items-center sm:justify-between w-full basis-full  sm:flex-row-reverse flex-col sm:h-full h-3/5'>
            <div className='flex basis-full w-full sm:basis-2/4 sm:ml-8 sm:h-auto'>
              <img className='w-full h-80 sm:h-2/4 sm:w-4/5 md:h-3/5' alt='kla' src={klaimage} />
            </div>
            <div className=' w-full flex ml-0 sm:h-5/6 md:h-auto   sm:basis-2/5 sm:ml-10 flex-row sm:mb-4 items-center justify-center'>
              <div className='flex items-center justify-center flex-row '>
                <div className='inline-grid sm:gap-y-3.5 gap-y-3 pb-4 sm:pb-0 ' >
                  <h1 className='font-bold text-3xl mb-4 '>Login</h1>
                  <p className='mb-6 text-sm sm:pr-0 md:pr-8'  >Welcome to Niyamasabha  webcasting Login Page.<br />
                  </p>

                  {!isLoginClicked ? <>
                    <form className='flex flex-col w-full' onSubmit={(e) => handleLogin(e)}>
                      <div className='flex  flex-col'>
                        <label htmlFor='email' className='text-lg'>Email</label>
                        {/*Input field for email*/}
                        <input id='email' value={values.email} className='p-5 h-16 w-full rounded' style={{ border: '1px solid #B1B1B1' }} type='email' placeholder='Enter your email' name='email' onChange={onInputChange} /><br />

                      </div>

                      <div className='flex flex-col'>
                        <label htmlFor='pass' className='text-lg'>Password</label>
                        {/* Input field for password */}
                        <div className=' flex flex-row ' >
                          <input value={values.password} id='pass' className='p-5 h-16 w-full rounded flex justify-between' style={{ border: '1px solid #B1B1B1' }} type={visibility ? 'text' : 'password'} placeholder='Enter your password' name='password' onChange={onInputChange} /><br />
                          <div className='flex items-center justify-center -ms-6'>
                            {visibility ? <IoEyeOutline onClick={onVisibility} /> : <IoEyeOffOutline onClick={onVisibility} />}
                          </div>
                        </div>

                      </div>
                      <div className='flex justify-between'>
                        <div>
                          {/* <input type='checkbox'/>Input field for remember me */}
                          {/* <label className='text-sm' style={{color:'#8E8E8E'}}>Remember me?</label> */}
                        </div>
                        {/* <label className='text-sm' style={{ color: '#8E8E8E' }} onClick={e => navigate('/forgotpassword')}>Forgot Password?</label> */}
                      </div>
                      <br />
                      <button
                        className={`rounded-lg text-white h-11 flex items-center justify-center transform duration-500 ease-in-out ${!loginDo ? 'bg-blue-700 hover:bg-blue-600' : 'bg-white border border-blue-700'}`}
                        // style={{ backgroundColor: '#1D4ED8' }}
                        onClick={(e) => handleLogin(e)}
                        disabled={loginDo}
                      >
                        {!loginDo ? (
                          'Submit'
                        ) : (
                          <div className="flex items-center gap-2">
                            <div className="loader border-t-2 w-4 h-4 rounded-full animate-spin"></div>
                            <span className='text-blue-700'>Loading...</span>

                          </div>
                        )}
                      </button>
                    </form>
                  </> :
                    <>
                      <div className='flex flex-row gap-2 items-center text-sm'>
                        <div className='text-blue-700 px-2 py-2 rounded gap-2 flex flex-row'>
                          <button onClick={handleEmailEdit} className='rounded px-2 border-blue-500 border hover:bg-blue-500 hover:text-white transition duration-500 ease-in-out flex flex-row gap-1 items-center'><Icon icon="mdi:email-edit-outline" /><span>Edit email</span></button>
                          <span className='border rounded px-2 border-blue-500 bg-blue-50'>{values?.email}</span>
                        </div></div>
                      <form onSubmit={(e) => handleSubmitOtp(e)} className='flex  flex-col w-full'>
                        <div>
                          <label htmlFor='otp' className='text-lg'>Enter OTP</label></div>
                        {/*Input field for otp*/}
                        <input
                          id='otp' className='p-5 h-10 w-full rounded' style={{ border: '1px solid #B1B1B1', letterSpacing: '0.5rem' }} type='number'
                          placeholder='Enter OTP' name='otp' onChange={(e) => setOtpInput(e.target.value)}
                          maxLength={6}
                          onInput={(e) => {
                            if (e.target.value.length > 6) {
                              e.target.value = e.target.value.slice(0, 6);
                            }
                          }} /><br />

                      </form>
                      <div className='text-sm flex flex-row gap-2 items-center'>
                        <span>Didn't receive OTP? </span>
                        {isCounting ? (
                          <button
                            disabled
                            className='hover:bg-blue-100 text-blue-700 border-blue-500 border rounded px-2 transition duration-500 ease-in-out cursor-not-allowed'
                          >
                            Resend in <span className='px-1 border-blue-200 mx-1 rounded bg-blue-50'>{timer}</span> sec
                          </button>
                        ) : (
                          <button
                            onClick={handleResendClick}
                            className='hover:bg-blue-100 text-blue-700 border-blue-500 border rounded px-2 transition duration-500 ease-in-out'
                          >
                            Resend Now
                          </button>
                        )}
                      </div>
                      <button className='rounded-lg text-white h-11 bg-color bg-blue-700 hover:bg-blue-600' onClick={(e) => handleSubmitOtp(e)}>LogIn</button>
                    </>
                  }

                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </>

  )
}

export default Login